import { render, staticRenderFns } from "./BasSupplierList.vue?vue&type=template&id=006d4010&scoped=true&"
import script from "./BasSupplierList.vue?vue&type=script&lang=js&"
export * from "./BasSupplierList.vue?vue&type=script&lang=js&"
import style0 from "./BasSupplierList.vue?vue&type=style&index=0&id=006d4010&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006d4010",
  null
  
)

export default component.exports